if (!customElements.get("product-dialogs")) {
  class ProductDialogs extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");
      this.activeDialog = null;
      this.activeButton = null;

      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Inizializza i trigger dei dialog
      this.querySelectorAll(".product__dialog--trigger").forEach(
        dialogTrigger => {
          dialogTrigger.addEventListener("click", evt => {
            this.openDialog(
              evt,
              dialogTrigger.dataset.dialog
            );
          });
        }
      );

      // Configura il comportamento dei dialog
      this.querySelectorAll("dialog").forEach(dialog => {
        // Aggiungi il click fuori dal dialog per chiudere
        dialog.addEventListener('click', (event) => {
          // Verifica se il click è stato sul backdrop (fuori dal contenuto del dialog)
          const rect = dialog.getBoundingClientRect();
          const isInDialog = (
            rect.top <= event.clientY &&
            event.clientY <= rect.top + rect.height &&
            rect.left <= event.clientX &&
            event.clientX <= rect.left + rect.width
          );
          if (!isInDialog) {
            dialog.close();
            this.updateButtonState(dialog.id, false);
          }
        });

        // Gestisci l'evento di chiusura del dialog
        dialog.addEventListener('close', () => {
          this.updateButtonState(dialog.id, false);
        });
      });
    }

    openDialog(evt, dialogId) {
      // Chiudi il dialog attivo se ce n'è uno
      if (this.activeDialog) {
        this.activeDialog.close();
      }

      const dialog = this.querySelector(`#${dialogId}`);
      if (dialog) {
        // Salva il dialog e il pulsante attivo
        this.activeDialog = dialog;
        this.activeButton = evt.currentTarget;
        
        // Attiva il pulsante
        this.updateButtonState(dialogId, true);
        
        // Salva la posizione di scorrimento attuale
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        
        // Apri il dialog in modalità modale (con backdrop)
        dialog.showModal();
        
        // Ripristina la posizione di scorrimento
        window.scrollTo({
          top: scrollPosition,
          behavior: 'auto' // Usiamo 'auto' invece di 'smooth' per evitare effetti visibili
        });
      }
    }

    updateButtonState(dialogId, isActive) {
      // Trova il pulsante relativo al dialog
      const trigger = this.querySelector(`.product__dialog--trigger[data-dialog="${dialogId}"]`);
      
      if (trigger) {
        if (isActive) {
          trigger.classList.add("active");
        } else {
          trigger.classList.remove("active");
        }
      }

      // Resetta le variabili se stiamo disattivando
      if (!isActive) {
        this.activeDialog = null;
        this.activeButton = null;
      }
    }
  }
  customElements.define("product-dialogs", ProductDialogs);
}
